import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { UserService } from '../../service/user.service';
import { playlist } from '../../models/playlist.model';
import { PlaylistPage } from '../playlist/playlist';
import { PlayerService } from '../../service/player.service';
import { PlaylistNewPage } from '../playlist-new/playlist-new';

/**
 * Generated class for the PlaylistsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-playlists',
  templateUrl: 'playlists.html',
})
export class PlaylistsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public us: UserService, private ps: PlayerService) {
  }

  loadPlaylist(playlist: playlist) {
    
    this.navCtrl.push(PlaylistPage, {playlist: playlist });

  }

  playPlaylist(playlist: playlist)
  {
      this.ps.playList = playlist.medias;
      this.ps.load(this.ps.playList[0].id, true);
  }

  new_playlist(){
    this.navCtrl.push(PlaylistNewPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/playlists/playlists.ts